import littlewoods from 'constants/littlewoods';
import verypay from 'constants/verypay';
import { insuranceVoucherMap } from 'constants/promotion-voucher-constants';

type Content = {
  [key: string]: string;
};

export default {
  ...littlewoods,
  ...insuranceVoucherMap,
  ...verypay,
  } as Content;
